import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectWorkTypeValue } from '../../services/workTypes/selectors';

interface Props {
    name?: ?string;
}

export class WorkTypeName extends React.PureComponent<Props> {
    render() {
        const { name } = this.props;
        if (!name) return null;
        return name;
    }
}

const mapStateToProps = createStructuredSelector({
    name: makeSelectWorkTypeValue('name')
});

export default connect(mapStateToProps)(WorkTypeName);
